export default {
  // Page titles
  title: "Cities",
  
  // Create page
  create: {
    title: "Create City",
  },
  
  // Edit page
  edit: {
    title: "Edit City",
  },
  
  // Fields
  fields: {
    id: "ID",
    name: "Name",
    country: "Country",
    localDeliveryFee: "Local Delivery Fee",
  },
  
  // Actions
  actions: {
    create: "Create City",
    update: "Update City",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    title: "Actions",
    cancel:"Cancel"
  },
  
  // Placeholders
  placeholders: {
    search: "Search cities...",
    enterName: "Enter city name",
    selectCountry: "Select Country",
    enterLocalDeliveryFee: "Enter local delivery fee",
  },
  
  // Validation
  validation: {
    nameRequired: "City name is required",
    countryRequired: "Country is required",
    deliveryFeeRequired: "Delivery fee must be a positive number",
    fillAllFields: "Please fill in all required fields",
  },
  
  // Messages
  messages: {
    createSuccess: "City created successfully",
    createError: "Failed to create city",
    updateSuccess: "City updated successfully",
    updateError: "Failed to update city",
    deleteSuccess: "City deleted successfully",
    deleteError: "Failed to delete city",
    deleteConfirm: "Are you sure you want to delete this city?",
    fetchError: "Failed to fetch cities",
    fetchCountriesError: "Failed to fetch countries",
    noCities: "No cities found",
    loading: "Loading cities...",
  },
};
